module.exports = __webpack_public_path__ + "img/pufayh.5b4d8b13.png";